export default __webpack_public_path__ + "static/media/trashBin.0213a092.svg";